module.exports = __webpack_public_path__ + "img/icon-fb.1da43801.svg";